import { useMemo } from "react";

import { Select } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Epic } from "../../bitmaker/schemas/Epic";

type ChartType = "timeStats" | "developmentMetrics";

interface Props {
  project: Epic;
  fromDate: Date;
  toDate: Date;
  selectedChart: ChartType;
  onChartChange: (value: ChartType) => void;
  onBack: () => void;
}

export const ProjectHeader = ({
  project,
  fromDate,
  toDate,
  selectedChart,
  onChartChange,
  onBack,
}: Props) => {
  const periodLabel = useMemo(() => {
    return `Period: ${fromDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
    })} - ${toDate.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
    })}`;
  }, [fromDate, toDate]);

  const projectTitle = `${project.project?.name} - ${project.subject}`;

  return (
    <div className="rounded-xl shadow-md bg-white text-gray-800 overflow-hidden">
      {/* Top bar */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 p-6">
        {/* Left: Back + Title */}
        <div className="flex items-center gap-4 min-w-0 flex-1">
          <button
            onClick={onBack}
            className="btn btn-gray flex items-center"
            type="button"
          >
            <ArrowLeftOutlined />
            Back to Projects
          </button>

          <h2 className="text-xl sm:text-2xl font-semibold text-gray-800 truncate">
            {projectTitle}
          </h2>
        </div>

        {/* Right: Period + Chart selector */}
        <div className="flex items-center gap-3 flex-wrap shrink-0">
          <span className="inline-block bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-sm">
            {periodLabel}
          </span>

          <div className="flex items-center gap-2">
            <span className="text-sm text-gray-600 shrink-0">Chart type</span>
            <Select
              value={selectedChart}
              options={[
                { value: "timeStats", label: "Time Stats" },
                { value: "developmentMetrics", label: "Development Metrics" },
              ]}
              onChange={onChartChange}
              className="w-full sm:w-48"
            />
          </div>
        </div>
      </div>
    </div>
  );
};
